import { useEffect, useState } from 'react';
import axios from 'axios';
import { feedsInitialData } from './FeedsInitialData';

export const useTradingData = (activeTab) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cache, setCache] = useState({});

  const fetchData = async (tab) => {
    if (cache[tab]) {
      setData(cache[tab]);
      setLoading(false);
      return;
    }

    const tabToMetaData = {
      'Крипто': feedsInitialData.Crypto.instruments,
      'Популярные инструменты': feedsInitialData.MostPopular.instruments,
      'Акции': feedsInitialData.Stocks?.instruments,
      'Сырьевые товары': feedsInitialData.Commodities?.instruments,
      'Индексы': feedsInitialData.Indices?.instruments,
      'Валюта': feedsInitialData.Forex?.instruments,
      'Опционы': feedsInitialData.Options?.instruments,
      'ETF': feedsInitialData.ETFs?.instruments,
      'Лидеры роста и падения': feedsInitialData.RisersAndFallers?.instruments,
    };

    const metaData = tabToMetaData[tab];
    if (!metaData || metaData.length === 0) {
      setData([]);
      setLoading(false);
      return;
    }

    const ids = metaData.map(i => i.instrumentId).join(',');
    const url = `https://www.plus500.com/ru-pl/api/LiveData/FeedsUpdates?instrumentIds=${ids}`;

    try {
      const response = await axios.get(url);
      const responseData = response.data || [];

      const processed = responseData.map(item => {
        const meta = metaData.find(m => m.instrumentId === Number(item.InstrumentId));

        return {
          name: meta?.name ?? `${item.InstrumentId}`,
          symbol: meta?.symbol ?? `ID ${item.InstrumentId}`,
          current_price: item.BuyPrice ?? '-',
          price: item.SellPrice ?? '-',
          price_change_percentage_24h: item.ChangePercent ?? null,
          image: meta?.instrumentIconImage ?? 'https://via.placeholder.com/35',
          tradingLink: meta?.tradingLink ?? '#',
        };
      });

      setCache(prev => ({ ...prev, [tab]: processed }));
      setData(processed);
    } catch (error) {
      console.error(`Ошибка загрузки данных для "${tab}":`, error);
      setData([]);
    } finally {
      
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(activeTab);
    const intervalId = setInterval(() => fetchData(activeTab), 3000);
    return () => clearInterval(intervalId);
  }, [activeTab]);

  return { data, loading };
};
